// extracted by mini-css-extract-plugin
export var critical = "styles-module--critical--6e693";
export var statusMessage = "styles-module--statusMessage--876b1";